/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleNameUpdateDto
 */
export interface RuleNameUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof RuleNameUpdateDto
     */
    name?: string;
}

/**
 * Check if a given object implements the RuleNameUpdateDto interface.
 */
export function instanceOfRuleNameUpdateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RuleNameUpdateDtoFromJSON(json: any): RuleNameUpdateDto {
    return RuleNameUpdateDtoFromJSONTyped(json, false);
}

export function RuleNameUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleNameUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function RuleNameUpdateDtoToJSON(value?: RuleNameUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

